// 别名库
import { SET_ALIAS_INFO, SET_MATCH_SUCCESS } from '../mutation-types'
const AliasManage = {
  state: {
    // 别名数据
    aliasInfo: null,
    // 保存状态
    isSuccess: false
  },
  getters: {
    aliasInfo: state => state.aliasInfo,
    isSuccess: state => state.isSuccess
  },
  mutations: {
    [SET_ALIAS_INFO] (state, aliasInfo) {
      state.aliasInfo = aliasInfo
      // 去匹配重置保存状态
      state.isSuccess = false
    },
    [SET_MATCH_SUCCESS] (state, isSuccess) {
      state.isSuccess = isSuccess
    }
  }
}

export default AliasManage



// WEBPACK FOOTER //
// ./src/store/modules/alias.js